import LoginComponent from './views/Login.vue';

const LoginPlugin = {
  install(Vue) {
    // 创建构造函数
    const LoginConstructor = Vue.extend(LoginComponent);
    
    // 创建实例
    let loginInstance = null;
    
    // 获取实例
    function getInstance() {
      if (!loginInstance) {
        loginInstance = new LoginConstructor({
          el: document.createElement('div')
        });
        document.body.appendChild(loginInstance.$el);
      }
      return loginInstance;
    }
    
    // 添加全局方法
    Vue.prototype.$login = {
      show(options = {}) {
        const instance = getInstance();
        
        // 可以在这里设置选项，如回调函数
        if (options.onSuccess) {
          instance.$once('login-success', options.onSuccess);
        }
        
        instance.show();
        return instance;
      },
      hide() {
        const instance = getInstance();
        instance.hide();
      }
    };
  }
};

export default LoginPlugin;    